import Clip from '@/api/clip'
import { Promise } from "es6-promise";

/**
 * initial state
 */
const state = {
    clips: [],
    articleList: [],
    placeList:[],
    userClipCategory: null,
    userClipCategoryError: null,
    userInterestList: [],
    userInterestedCategory: '',
    matcaCategoryList: []
}

/**
 * getters
 */
const getters = {
    clips: state => state.clips,
    articleList: state => state.articleList,
    placeList: state => state.placeList,
    userClipCategory: state => state.userClipCategory,
    userClipCategoryError: state => state.userClipCategoryError,
    userInterestList: state => state.userInterestList,
    userInterestedCategory: state => state.userInterestedCategory,
    matcaCategoryList: state => state.matcaCategoryList
}

/**
 * actions
 */
const actions = {

    getClipList({ commit }, params) {
        Clip.getClipList(params)
            .then(data => {
                commit('CLIPS_GET_SUCCESS', data)
            })
            .catch(error => {
                commit('CLIPS_GET_ERROR', error)
            })
    },

    getArticlesDetails({ commit }, params) {
        commit('SET_ARTICLE_LIST', params)
    },

    getPlaceDetails({ commit }, params) {
        commit('SET_PLACES_LIST', params)
    },

    removeArticleFromStore({ commit }, params) {
        commit('REMOVE_FROM_ARTICLE_LIST', params)
    },

    removePlaceIdFromStore({ commit }, params) {
        commit('REMOVE_FROM_PLACE_LIST', params)
    },

    addArticleToStore({ commit }, params) {
        commit('ADD_TO_ARTICLE_LIST', params)
    },

    getAllClipCategory({ commit }, params) {
        Clip.getAllClipCategory(params)
            .then(data => {
                commit('GET_ALL_CLIP_CATEGORY', data)
            })
            .catch(error => {
                commit('GET_ALL_CLIP_CATEGORY_ERROR', error)
            })

    },
    setUserInterestList({commit}, data){
        commit('SET_USER_INTEREST_LIST', data);
    },

    setUserInterestedCategory({commit}, data){
        commit('SET_USER_INTERESTED_CATEGORY', data)
    },
    setMatcaCategoryList({commit}, data){
        commit('SET_MATCHA_CATEGORY_LIST', data)
    }
}

/**
 * mutations
 */
const mutations = {

    SET_ARTICLE_LIST(state, data) {
        // console.log(data)
        state.articleList = data
        // data.forEach(article => {
        //   state.articleList = article.title
        // });
    },

    SET_PLACES_LIST(state, data){
        // console.log(data);
        state.placeList = data;
    },

    CLIPS_GET_SUCCESS(state, data) {
        state.clips = data.articles
    },

    REMOVE_FROM_ARTICLE_LIST(state, data) {
        let store_data = state.articleList
        store_data.forEach((post, index) => {
            if (post.article_id === parseInt(data)) {
                state.articleList.splice(index, 1)
            }
        })
    },

    REMOVE_FROM_PLACE_LIST(state, data){
        let store_data = state.placeList
        store_data.forEach((post, index) => {
            if (post.id === data) {
                state.placeList.splice(index, 1)
            }
        })
    },

    ADD_TO_ARTICLE_LIST(state, data) {
        state.articleList.push(data)
    },

    GET_ALL_CLIP_CATEGORY(state, data) {
        state.userClipCategory = data
    },

    GET_ALL_CLIP_CATEGORY_ERROR(state, message) {
        state.userClipCategoryError = message
    },
    SET_MATCHA_CATEGORY_LIST(state, data){
        state.matcaCategoryList = data
    },
    SET_USER_INTEREST_LIST(state, data){
        state.userInterestList = data    
    },
    SET_USER_INTERESTED_CATEGORY(state, data){
        let user_category = state.matcaCategoryList.filter((cat) => {
            if(state.userInterestList.indexOf(cat.category_id) >= 0){
                return cat;
            }
        })
        
        let map_category = user_category.map((cat) => {
            return cat.category_name;
        }) 

        if(map_category.length > 0){
            state.userInterestedCategory = map_category.join(', ')
        }else{
            state.userInterestedCategory = ''
        }
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/clip.js